import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { PaginatorService } from './services/paginator.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PaginationComponent } from './components/pagination/pagination.component';

@NgModule({
    imports: [ CommonModule, FontAwesomeModule ],
    providers: [ PaginatorService ],
    declarations: [
        PaginatorComponent,
        PaginationComponent
    ],

    exports: [
        PaginatorComponent,
        PaginationComponent
    ]
})
export class ContPaginatorModule { }
